import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import loadCardCreateConfigService from '../../services/load-card-create-config';
import {
	type LoadCardCreateConfigAction,
	type LoadConfigDataModelSuccess,
	loadCardCreateConfigSuccess,
	loadCardCreateConfigFailure,
	LOAD_CARD_CREATE_CONFIG_REQUEST,
	LOAD_CONFIG_DATA_MODEL_SUCCESS,
} from '../../state/actions/app';
import { getJqlQuery } from '../../state/selectors/app';
import type { ActionsObservable, Dependencies, MiddlewareAPI } from '../../state/types';

export const loadCardCreateConfigEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
	dependencies?: Dependencies,
) =>
	action$
		.ofType(LOAD_CARD_CREATE_CONFIG_REQUEST, LOAD_CONFIG_DATA_MODEL_SUCCESS)
		.flatMap((action: LoadCardCreateConfigAction | LoadConfigDataModelSuccess) => {
			const state = store.getState();
			const jqlQuery =
				action.type === LOAD_CONFIG_DATA_MODEL_SUCCESS
					? action.payload.config.jqlQuery
					: getJqlQuery(state) || '';

			const analyticsEvent =
				dependencies && dependencies.createAnalyticsEvent
					? dependencies.createAnalyticsEvent({
							action: 'load',
							actionSubject: 'cardCreateConfig',
						})
					: undefined;

			return loadCardCreateConfigService(jqlQuery)
				.map((cardConfigResponse) =>
					loadCardCreateConfigSuccess(cardConfigResponse, analyticsEvent),
				)
				.catch((error: FetchError) => {
					log.safeErrorWithoutCustomerData(
						'backlog.load-card-create-config.failure',
						'Failed to load card create config from REST',
						error,
					);
					return Observable.of(loadCardCreateConfigFailure(error, analyticsEvent));
				});
		});
